import React from 'react';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import ProductList from '../Product/ProductList';
import Snackbar from 'material-ui/Snackbar';

class ChooseProducts extends React.Component {
  constructor(props) {
    super(props);
    const {standKey} = this.props.match.params;
    this.initialState =  {
      products:[],
      standKey,
      standname:'',
      snackbarOpen: false,
      snackbarMessage: ''
    };

    this.state = {
      ...this.initialState
    };

  }
  componentDidMount = () => {
    const {firebase, user} = this.props;
    
    firebase.database().ref(`shopkeepers/${user.shopkeeperId}/stands/${this.state.standKey}/products/`)
    .once('value', (products) => {
      const currentProducts = [];
      products.forEach((data) => {
        const product = {
          key: data.key,
          ...data.val()
        };
        currentProducts.push(product);
      });
      this.setState({products: currentProducts});
    });
    firebase.database().ref(`shopkeepers/${user.shopkeeperId}/stands/${this.state.standKey}/name`)
    .once('value', (data) => {
      this.setState({standname: data.val()});
    });
  }
  handleAddProduct = (product) => {
    const {shopkeeperId} = this.props.user;
    const {firebase} = this.props;
    const {t} = this.props;
    const {key, pictureUrl, selected, ...data}  = product; // eslint-disable-line
    firebase.database().ref(`shopkeepers/${shopkeeperId}/stands/${this.state.standKey}/products/${key}/`).set(data);
    const currentProducts = this.state.products.slice();
    currentProducts.push(product);
    this.setState({products: currentProducts,
      snackbarOpen: true,
      snackbarMessage: `${product.name} ${t('addedto')} ${this.state.standname}`});
  }
  handleRemoveProduct = (product) => {
    const {shopkeeperId} = this.props.user;
    const {firebase} = this.props;
    const {t} = this.props;
    firebase.database().ref(`shopkeepers/${shopkeeperId}/stands/${this.state.standKey}/products/${product.key}/`).remove();
    const currentProducts = this.state.products.slice();
    const index = currentProducts.findIndex((item) => (item.key === product.key));
    currentProducts.splice(index, 1);
    this.setState({products: currentProducts,
      snackbarOpen: true,
      snackbarMessage: `${product.name} ${t('removedfrom')} ${this.state.standname}`});
  }
  handleSelectChange = (select , product) => select ? this.handleAddProduct(product) : this.handleRemoveProduct(product);

  handleCancel = () => {
    this.setState({ ...this.initialState});
    this.props.handleClose();
  }
  closeSnackbar = () => {
    this.setState({snackbarOpen: false,
      snackbarMessage: ''});
  }
  render() {
    return (
      <div>
        <ProductList onCheck={this.onCheck} selectedProducts={this.state.products} onSelectChange={this.handleSelectChange} standname={this.state.standname}/>
        <Snackbar
          open={this.state.snackbarOpen}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this.closeSnackbar}/>
        </div>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(ChooseProducts);



// WEBPACK FOOTER //
// ./src/Stand/ChooseProducts.js